export default `{
	"list": [
		{
			"type": "input",
			"name": "单行文本",
			"options": {
				"width": "100%",
				"defaultValue": "",
				"placeholder": "请输入",
				"disabled": false,
				"params": {
            "no": "getAllStorer",
            "args": null
        },
        "targetField": "STORER_NO"
			},
			"model": "input_1568988693010",
			"key": "input_1568988693010",
			"rules": [
				{
					"required": true,
					"message": "单行文本必须填写"
				}
			]
		}
	],
	"config": {
		"layout": "horizontal",
		"labelCol": {
			"span": 4
		},
		"wrapperCol": {
			"span": 18
		},
		"colon": true
	},
	"dataSource": {
    "sql": "select t1.no,t1.id,t1.invoice_time,t2.name as order_type_name,t3.name as storer_name,t1.buyer,t4.name as customer_name\\n  from purchase_order t1, order_type t2, storer t3,customer t4\\n where 1 = 1\\n   and t1.order_type_id = t2.id\\n   and t1.storer_id = t3.id\\n\\t and t1.customer_id = t4.id\\n   and (t1.no = :no or :no is null)\\n   and (t3.no = :storer or :storer is null)\\n   and (t4.no = :customer or :customer is null)",
    "columns": "[\\n\\t{\\n\\t\\t\\"type\\": \\"checkbox\\",\\n\\t\\t\\"width\\": 50\\n\\t},\\n\\t{\\n\\t\\t\\"type\\": \\"seq\\",\\n\\t\\t\\"title\\": \\"business.label.indexNo\\",\\n\\t\\t\\"width\\": 100,\\n\\t\\t\\"fixed\\": \\"left\\"\\n\\t},\\n\\t{\\n\\t\\t\\"field\\": \\"NO\\",\\n\\t\\t\\"sortable\\": true,\\n\\t\\t\\"title\\": \\"business.label.orderNo\\",\\n\\t\\t\\"width\\": 150\\n\\t},\\n\\t{\\n\\t\\t\\"field\\": \\"INVOICE_TIME\\",\\n\\t\\t\\"sortable\\": true,\\n\\t\\t\\"showOverflow\\": true,\\n\\t\\t\\"title\\": \\"business.label.invoiceDate\\",\\n\\t\\t\\"formatter\\": \\"formatterDate\\",\\n\\t\\t\\"width\\": 150\\n\\t},\\n\\t{\\n\\t\\t\\"field\\": \\"BUYER\\",\\n\\t\\t\\"title\\": \\"business.label.buyer\\",\\n\\t\\t\\"sortable\\": true,\\n\\t\\t\\"width\\": 100\\n\\t},\\n\\t{\\n\\t\\t\\"field\\": \\"STORER_NAME\\",\\n\\t\\t\\"title\\": \\"business.label.storer\\",\\n\\t\\t\\"sortable\\": true,\\n\\t\\t\\"width\\": 100\\n\\t},\\n\\t{\\n\\t\\t\\"field\\": \\"CUSTOMER_NAME\\",\\n\\t\\t\\"title\\": \\"business.label.customerName\\",\\n\\t\\t\\"sortable\\": true,\\n\\t\\t\\"width\\": 100,\\n\\t\\t\\"filters\\":[{\\"data\\": {\\"vals\\": [], \\"sVal\\": \\"\\", \\"fMenu\\": \\"\\", \\"f1Type\\":\\"\\", \\"f1Val\\": \\"\\", \\"fMode\\": \\"and\\", \\"f2Type\\": \\"\\", \\"f2Val\\": \\"\\"}}],\\n\\t\\t\\"filter-render\\": {\\n\\t\\t\\t\\"name\\": \\"FilterExcel\\"\\n\\t\\t}\\n\\t},\\n\\t{\\n\\t\\t\\"field\\": \\"ORDER_TYPE_NAME\\",\\n\\t\\t\\"title\\": \\"business.label.orderType\\",\\n\\t\\t\\"sortable\\": true,\\n\\t\\t\\"width\\": 100\\n\\t}\\n]",
    "no": "queryTest",
    "name": "查询测试。。",
    "type": "3",
    "paramModel":"",
    "queryType":"",
    "apiDesc":{
     "method":"post",
     "url":"",
     "headers":""
    }
  }
}`;
